import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import BookingTicketForm from '../../../../Componant/Application/Project/master/BookingTicketForm'


const BookTicketContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <BookingTicketForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default BookTicketContainer